import { deviceConstants } from './device.constants';

const initialState = { name: deviceConstants.DEVICE, isActive: true, deviceDetail: {}, storeDetail: {} };

function deviceReducer(state = initialState, action) {
    switch (action.type) {
        case deviceConstants.DEVICE:
            const { name, isActive } = action.payload;
            return {
                ...state,
                name: name,
                isActive: isActive
            };
        case deviceConstants.SET_DEVICEINFO:            
            return {
                ...state,
                deviceDetail: action.payload.device,
                storeDetail: action.payload.store                
            };
        default:
            return state
    }
}

export { deviceReducer };